import {
    getCommandBarSelectionCount,
    getCommandBarSelectionLabel,
    hasCommandBarSelection,
    shouldShowCommandBarGlobalCommands,
    shouldShowCommandBarSelectionCount
} from "./CommandBarSelectionHelper";

export const hasSubscriptionSelection = hasCommandBarSelection;

export const shouldShowSubscriptionGlobalCommands = shouldShowCommandBarGlobalCommands;

export const getSubscriptionSelectionCount = getCommandBarSelectionCount;

export const shouldShowSubscriptionSelectionCount = shouldShowCommandBarSelectionCount;

export const getSubscriptionSelectionLabel = getCommandBarSelectionLabel;
